import React, { useState } from "react"
import "./Navbar.scss"
import { AiOutlineMenu, AiFillHome, AiOutlineUser, AiOutlineMail, AiOutlineCopyrightCircle, AiOutlineUnlock } from "react-icons/ai"
import { BiMoon, BiDoughnutChart, BiBarChartSquare, BiChart, BiFolder } from "react-icons/bi"
import { FaUserPlus, FaUserFriends } from 'react-icons/fa'
import { MdOutlineContentCopy } from 'react-icons/md'
import { images } from '../../constants';

const Navbar = () => {
    const handleClick = () => {
        setIsOpen(!isOpen)
    }
    const [isOpen, setIsOpen] = useState(false)

    return (
        <div >
            <div className="Navbar">
                <div className="left__nav">
                    <AiOutlineMenu onClick={() => setIsOpen(true)} className="navbar__menubar" />
                    <p className="navbar__name">Kyilax Portfolio</p>
                </div>
                <div className="right__nav">
                    <a href="#home" className="navbar__links nav-h">
                        Home
                    </a>

                    <a href="#about" className="navbar__links nav-h">
                        About
                    </a>

                    <a href="#work" className="navbar__links nav-h">
                        Work
                    </a>

                    <a href="#skills" className="navbar__links nav-h">
                        Skills
                    </a>

                    <a href="#contact" className="navbar__links nav-h">
                        Contact
                    </a>
                </div>
            </div>
            {isOpen && (

                <div className="sidebar-con" >

                    <nav class="sidebar" >
                        <div className="side-img">
                            <img src={images.me} alt="" />
                        </div>

                        <ul>
                            <a href="#home">
                                <li className="sidebar__links">
                                    Home
                                </li>
                            </a>

                            <a href="#about">
                                <li className="sidebar__links">
                                    About
                                </li>
                            </a>

                            <a href="#work">
                                <li className="sidebar__links">
                                    Work
                                </li>
                            </a>

                            <a href="#skills">
                                <li className="sidebar__links">
                                    Skills
                                </li>
                            </a>

                            <a href="#contact">
                                <li className="sidebar__links">
                                    Contact
                                </li>
                            </a>

                        </ul>
                    </nav>
                    <div className="side-overlay" onClick={() => setIsOpen(false)}></div>
                </div>
            )}
        </div>
    )
}

export default Navbar
